'use strict';

const common = {
  black: '#000',
  white: '#fff'
};

module.exports = common;
//# sourceMappingURL=common.cjs.map
